export default "__VITE_ASSET__WhrVdcjz__"